import React, { Component } from 'react';

import { ResponsiveLine } from '@nivo/line';
import { chartColors } from './chartColors';

class LineGraphNoLegends extends Component {
  render() {
    return (
      <div className="line-graph" style={{width: 100 + '%', height: this.props.height + 'px'}}>
        <ResponsiveLine
          data={this.props.data}
          margin={{
              "top": 0,
              "right": 0,
              "bottom": 0,
              "left": 0
          }}
          colors={chartColors.investmentSummary}
          minY="auto"
          stacked={true}
          enableAxisBottom={false}
          axisBottom={{
              "orient": "bottom",
              "tickSize": 300,
              "tickPadding": 0,
              "tickRotation": 0,
              "legend": "",
              "legendOffset": 0,
              "legendPosition": "center",
              "colors": ['rgba(35, 207, 203, 0)']
          }}
          axisLeft={{
              "orient": "left",
              "tickSize": 0,
              "tickPadding": 0,
              "tickRotation": 0,
              "legend": "",
              "legendOffset": 0,
              "legendPosition": "center"
          }}
          enableGridX={false}
          enableGridY={false}
          enableDots={false}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
          isInteractive={false}
          enableStackTooltip={false}
          legends={[
              {
                  "anchor": "bottom-right",
                  "direction": "column",
                  "translateX": 0,
                  "itemWidth": 0,
                  "itemHeight": 0,
                  "symbolSize": 0,
                  "symbolShape": "circle",
                  "color": "rgba(255, 255, 255, 1)"
              }
          ]}
        /> 
      </div>
    );
  }
  
}

export default LineGraphNoLegends;
